import { Button, Grid } from '@material-ui/core'
import React, { useEffect, useState } from 'react'
import { AsterToggleButton, AsterToggleButtonGroup } from 'asterX-UI/Buttons/toggle-button'

import { PluseIcon } from 'asterX-UI/Icons/PlusIcon'
import { useAuthStore } from 'context/AuthStore'
import { useContractStore } from 'context/ContractStore'
import { useStyles } from './contract.styles'
import { contractTypes } from './const'
import { UploadedFiles } from './components/UploadedFiles/UploadedFiles'
import { UploadFilesModal } from './components/UploadFilesModal/UploadFilesModal'

export const FileContract = () => {
  const classes = useStyles()

  const { authStoreFunc } = useAuthStore()
  const [activeTab, setActiveTab] = useState('bs-files')
  const [openUploadFile, setOpenUploadFile] = useState(false)
  const {
    contractStore: { contractAll },
    contractStoreFunc
  } = useContractStore()

  useEffect(() => {
    if (contractAll?.id) {
      contractStoreFunc.getWlFiles(contractAll?.id)
    }
    if (!authStoreFunc.isAdmin()) {
      contractStoreFunc.getFileTypes()
    }
  }, [])

  return (
    <Grid container className={classes.wrapper}>
      <Grid item container className={classes.actionBtns}>
        <AsterToggleButtonGroup
          exclusive
          value={activeTab}
          onChange={(e, val) => {
            setActiveTab(val)
          }}
        >
          {contractTypes.map(({ label, code }, i) => (
            <AsterToggleButton key={`table-toggle-btn-${code}`} value={code}>
              {label}
            </AsterToggleButton>
          ))}
        </AsterToggleButtonGroup>
        {!authStoreFunc.isAdmin() && (
          <Grid item className={classes.addFileBtn}>
            <Button fullWidth variant="outlined" onClick={() => setOpenUploadFile(true)}>
              <PluseIcon />
              Загрузить файл
            </Button>
          </Grid>
        )}
      </Grid>

      {activeTab === 'bs-files' && (
        <Grid item container className={classes.contentCard}>
          <UploadedFiles />
        </Grid>
      )}
      {activeTab === 'client-files' && (
        <Grid item container className={classes.contentCard}>
          <UploadedFiles client />
        </Grid>
      )}
      {activeTab === 'credit-flow-files' && (
        <Grid item container className={classes.contentCard}>
          <UploadedFiles creditFlow={true} />
        </Grid>
      )}
      <UploadFilesModal
        open={openUploadFile}
        onCancel={() => setOpenUploadFile(false)}
        onClose={() => setOpenUploadFile(false)}
      />
    </Grid>
  )
}
